import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ReactQueryDevtools } from 'react-query/devtools'
import MainLayout from './layouts/MainLayout'
import PrivateRoute from './components/PrivateRoute'
import Home from './pages/Home'
import Drilldown from './pages/Drilldown'
import NotFound from './pages/NotFound'
import Users from './pages/Users'
import Announcements from './pages/Announcements'
import Announcement from './pages/Announcement'
import Reports from './pages/Reports'
import Login from './pages/Login'
import Report from './pages/Report'

const queryClient = new QueryClient()

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<MainLayout />}>
          <Route 
            index 
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            } 
          />
          <Route 
            path='/kpi/:id' 
            element={
              <PrivateRoute>
                <Drilldown />
              </PrivateRoute>
            } 
          />
          <Route 
            path='/users' 
            element={
              <PrivateRoute>
                <Users />
              </PrivateRoute>
            } 
          />
          <Route
            path='/announcements'
            element={
              <PrivateRoute>
                <Announcements />
              </PrivateRoute>
            }
          />
          <Route 
            path='/announcements/:id'
            element={
              <PrivateRoute>
                <Announcement />
              </PrivateRoute>
            }
          />
          <Route
            path='/reports'
            element={
              <PrivateRoute>
                <Reports />
              </PrivateRoute>
            }
          />
          <Route
            path='/reports/:id'
            element={
              <PrivateRoute>
                <Report />
              </PrivateRoute>
            }
          />
          <Route path='/login' element={<Login />} />
          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AppRoutes />
        {
          process.env.NODE_ENV === 'development' && (
            <ReactQueryDevtools initialIsOpen={false} />
          )
        }
      </LocalizationProvider>
    </QueryClientProvider>
  )
}
export default App
